import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import FooterAccordionStyles from './FooterAccordion.module.scss';

export const FooterAccordion: React.FC = ({ children }) => {
  return (
    <Accordion className={FooterAccordionStyles.footer_accordion}>
      <Accordion.Item eventKey="0" className={FooterAccordionStyles.footer_accordion__item}>
        <Accordion.Header className={FooterAccordionStyles.footer_accordion__item_header}>
          Site Map
        </Accordion.Header>
        <Accordion.Body className={FooterAccordionStyles.footer_accordion__item_body}>
          {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
